<template>
	<div class="rht-view report-allocations report-turnover-alloc-parent report-qcen">
		<GeminiScrollbar class="my-scroll-bar">
			<div
				class="table-container"
				:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}"
				:class="(allocations.length == 0)? 'empty-view':'filled-view'"
			>
				<div class="master-head">
					<!--Loop through the allocation data to set the month-year header-->
					<template v-for="(allocation,index) in allocations">
						<div class="master-head-month" :key="index">
							<h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
						</div>
					</template>
				</div>
				<div class="table-wrapper">
					<div class="master-table-head-box">
						<div
							class="each-month each-month-header each-month-turnover-header"
							:key="index"
							v-for="(allocation,index) in allocations"
						></div>
					</div>
					<div
						class="master-table master-report-table master-table-loaded"
						id="scroll-table"
						v-bar="{scrollThrottle: 30,draggerThrottle: 4}"
					>
						<scroll-sync group="report" vertical>
							<template v-for="(allocation, index) in allocations">
								<div class="report-alloc-tr each-turn-col" :key="index">
									<div
										class="each-turn"
										v-for="(countriesTurnOvers,turnoverIndex) in allocation.countriesTurnOvers"
										:key="turnoverIndex"
									>
										<div class="master-table-text right-table-header alloc-value">
											<p class="right-td">{{countriesTurnOvers.turnOver|money}}€</p>
										</div>
									</div>
								</div>
							</template>
						</scroll-sync>
					</div>
				</div>

				<!-- Report -->
				<div class="month-report-bottom bottom-alloc-gutters">
					<div class="report-left-list">
						<template v-for="(result,index) in results">
							<div class="each-turn" :key="index">
								<div class="master-table-text right-table-header alloc-value">
									<p class="right-td">{{result.internal.turnOver| money | truncate(9)}}€</p>
								</div>
								<div class="master-table-text right-table-header alloc-value">
									<p class="right-td">{{result.external.turnOver| money | truncate(9)}}€</p>
								</div>
								<div class="master-table-text right-table-header alloc-value">
									<p class="right-td">{{result.total.turnOver| money | truncate(9)}}€</p>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</GeminiScrollbar>
	</div>
</template>

<script>
import { setTimeout } from "timers";
import filters from "../../../../mixins/filters";

export default {
  name: "QcentriscountryAllocation",
  mixins: [filters],
  data() {
    return {
      masterTableWidth: 0,
      masterTableFinalWidth: 0,
      monthTableWidth: 0,
      isDomReady: false,
      allocationLength: 0,
      loaderClass: ""
    };
  },
  computed: {
    /**
     * Allocation data from store
     */
    allocations: function() {
      return this.$store.state.reports.qcentrisCountryTurnoverAllocations;
    },

    results: function() {
      return this.$store.state.reports.reportAggregate;
    }
  },
  updated() {
    this.setTableWidth();
    this.updateLoader();
  },
  created() {
    // Hiding the loader once the component is created
    this.isDomReady = true;
    this.updateLoader();
  },
  mounted() {
    this.setTablePadding();

    setTimeout(() => {
      //this.HeadHorizontalScroll();
    }, 500);
  },
  methods: {
    /**
     * Set the width after the data load
     */
    setTableWidth: function() {
		//Adding actual width
      this.masterTableWidth = 190 * this.allocations.length + 10;
	},
    setTablePadding: function() {
      setTimeout(() => {
        this.masterTableWidth += 100;
      }, 800);
    },
    /**
     * Set the loader class on all component loaded
     */
    updateLoader: function() {
      setTimeout(() => {
        if (
          typeof this.$refs.allocationRow !== "undefined" &&
          this.$refs.allocationRow.length === this.allocations.length
        ) {
          this.loaderClass = "master-table-loaded";
        }
      }, 200);
    },

    HeadHorizontalScroll: function() {
      let ScrollElement = this.$refs.masterHeadScroll,
        scrollableElement = document.querySelector(
          ".alloc-my-scrollbar .gm-scroll-view"
        ),
        i = 0;

      ScrollElement.addEventListener("wheel", function(e) {
        //When dragging to left side
        if (e.deltaY < 0 && !e.shiftKey) {
          if (i >= 0) {
            //if Scroll left == 0
            scrollableElement.scrollLeft = i;
            i = i - 50;
          } else {
            i = 0;
          }
        }

        //Mouse wheel and horizontal scroll for allocation's headers
        else if (e.deltaY > 0 && !e.shiftKey) {
          if (i <= scrollableElement.scrollWidth) {
            //if Scroll left !== end of the div
            scrollableElement.scrollLeft = i;
            i = i + 50;
          } else {
            i = scrollableElement.scrollWidth;
          }
        }
      });
    }
  },
  watch: {
    /**
     * Watch if the allocation data is fetch
     */
    allocations: function() {
      // call the function after the allocation data is loaded
      this.setTableWidth();
    }
  }
};
</script>

<style scoped>
	.master-head-month,
	.master-head-month:first-child {
		width: 190px;
		min-width: 190px;
		text-align: center;
	}

	.master-head-month h3,
	.report-allocations .each-turn p {
		text-align: center;
	}

	.report-allocations .each-turn p {
		/* line-height: 23.48px; */
	}

	/* first child from each row */
	.report-allocations
		.month-report-bottom
		.each-turn
		.alloc-value:first-of-type
		p {
		/* padding-top: 16px; */
	}

	.report-allocations .month-report-bottom .each-turn .alloc-value p {
		/* padding: 8.5px 0 !important; */
	}

	.report-allocations .each-turn {
		width: 190px;
		min-width: 190px;
		border-right: 1px solid #dee1e3;
	}

	.report-allocations .each-month {
		width: 190px;
		min-width: 190px;
		border-right: 1px solid #dee1e3;
	}

	.master-head-month {
		border-right: 1px solid #dee1e3;
	}

	.month-report-bottom {
		/* height: auto;
					height: auto;
					height: auto; */
	}

	.each-turn {
		border-bottom: 1px solid #dee1e3;
	}

	.each-turn p {
		padding: 22px 0;
		font-weight: 600;
		color: #000000;
	}

	.each-turn .alloc-value:first-of-type p {
		/* padding-top: 31px !important; */
	}

	.each-month tr > .right-td {
		padding-top: 0 !important;
		padding-bottom: 13px !important;
	}

	.unit.report-alloc-tr.each-turn-col {
		float: left;
		width: unset !important;
		min-width: 271px;
	}

	.report-allocations .each-turn-col {
		float: left;
		width: 190px;
		min-width: 190px;
	}

	/* Master table on Unit turnover */
	.master-table {
		max-height: calc(100vh - 300px);
		min-height: calc(100vh - 300px);
		height: calc(100vh - 300px);
	}

	.report-allocations .month-report-bottom .report-left-list > div {
		height: 100%;
	}
	.report-allocations .month-report-bottom .each-turn {
		border-bottom: none;
		height: 100%;
	}

	.report-allocations .each-turn p {
		padding: 0;
	}

	.month-report-bottom .report-left-list .each-turn {
		padding-left: 0;
	}

	.month-report-bottom
		.each-turn
		.master-table-text.right-table-header.alloc-value {
		border-bottom: 1px solid #cccccc;
	}

	.month-report-bottom
		.each-turn
		.master-table-text.right-table-header.alloc-value:last-child {
		border-bottom: none;
	}

	.month-report-bottom.bottom-alloc-gutters .report-left-list {
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
	}
</style>
